import { render, staticRenderFns } from "./PopupAddItem.vue?vue&type=template&id=a95a3624"
import script from "./PopupAddItem.vue?vue&type=script&lang=js"
export * from "./PopupAddItem.vue?vue&type=script&lang=js"
import style0 from "./PopupAddItem.vue?vue&type=style&index=0&id=a95a3624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports